import { createInMemoryAtom } from '@exodus/atoms';
import type { Definition } from '@exodus/dependency-types';

import type { App } from '../types.js';

const createAppsAtom = () =>
  createInMemoryAtom<App[]>({
    defaultValue: [],
  });

const appsAtomDefinition = {
  id: 'appsAtom',
  type: 'atom',
  factory: createAppsAtom,
} as const satisfies Definition;

export type AppsAtom = ReturnType<typeof appsAtomDefinition.factory>;

export default appsAtomDefinition;
